// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/assets/css/vendor.css
// module id = 308
// module chunks = 0